import React, { useState, useEffect } from 'react';
import {
  notification, PageHeader, Result, Image, Row, Col
} from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Breadcrumb from 'components/BreadCrumb';
import RecipesTable from 'containers/computers/recipes/table';
import { saveRecipe, fetchRecipesWithSpecifications, deleteSelectedRecipe } from 'utils/recipes';
import SpecificationFlow from 'containers/specifications/generationFlow';
import AuthenticatorWithEmail from 'utils/authentificator';

const ImageFile = require('./assets/recipes.png');

const Recipes = (props) => {
  const [recipes, setRecipes] = useState([]);
  const [recipe, setRecipe] = useState([]);
  const [hasRecipeToSave, setRecipeToSave] = useState(false);
  const [specifications, setSpecifications] = useState(false);
  const { location: { state } } = props;

  const fetcRecipes = async () => {
    try {
      const list = await fetchRecipesWithSpecifications();
      // eslint-disable-next-line no-underscore-dangle
      setRecipes(list?.data?.listFormulas?.items.filter(item => !item._deleted));
    } catch (e) {
      console.error(e.toString());
    }
  };

  // eslint-disable-next-line consistent-return
  const handleGenerateSpecification = (SpecificationRecipe) => {
    if (!SpecificationRecipe) return false;
    setRecipe(SpecificationRecipe);
    setSpecifications(true);
  };

  useEffect(async () => {
    if (!_.isEmpty(state?.recipe)) {
      await saveRecipe(state?.recipe);
      setRecipeToSave(true);
    }
    await fetcRecipes();
  }, []);

  const handleDeleteRecipe = async (recipeId) => {
    try {
      await deleteSelectedRecipe(recipeId);
      notification.success({
        message: 'Recette supprimées avec succès',
      });
      await fetcRecipes();
    } catch (e) {
      notification.error({
        message: 'Erreur lors de la suppression de votre recette',
        description: e.toString(),
      });
      console.error(e.toString());
    }
  };

  const renderNewRecipe = () => {
    if (!hasRecipeToSave) {
      return false;
    }
    return (
      <Result
        status="success"
        title={`${state?.recipe?.name} a été ajoutée à vos recettes`}
      />
    );
  };

  return (
    <AuthenticatorWithEmail>
      {!specifications && (
        <>
          <PageHeader
            style={{ border: '1px solid #d9d9d9' }}
            title="Mes recettes"
            breadcrumb={(
              <Breadcrumb
                items={[
                  ['Accueil', '/'],
                  ['Mes recettes'],
                ]}
              />
            )}
          />
          <InnerContent>
            <Row justify="center" type="flex" align="middle">
              <Col span={6}>
                <Image src={ImageFile.default} width="100%" preview={false} />
              </Col>
            </Row>
            {renderNewRecipe()}
            <RecipesTable
              recipes={recipes}
              deleteSelectedRecipe={handleDeleteRecipe}
              handleGenerateSpecification={handleGenerateSpecification}
            />
          </InnerContent>
        </>
      )}
      {specifications && !_.isEmpty(recipe) && (
        <SpecificationFlow recipe={recipe} setSpecifications={setSpecifications} />
      )}
    </AuthenticatorWithEmail>
  );
};

Recipes.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      recipe: PropTypes.shape({
        name: PropTypes.string,
        userId: PropTypes.string,
        ingredients: PropTypes.shape({
          condition: PropTypes.string,
          ingredient: PropTypes.string,
          themes: PropTypes.string
        })
      })
    })
  })
};

const InnerContent = styled.div`
  background: #fff;
  margin: 0px;
  margin-top: 20px;
`;

export default Recipes;
